import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import AppkitIcon from '../../appkitIcon/appkitIcon.component';
import { toImageDataUrl } from '../../../utils/imageDataUrl';

const SingleAttachment = ({
  file,
  onRemove,
  withThumbnail,
}) => {
  const removeHandler = useCallback(() => onRemove(file), [file, onRemove]);

  return (
    <div className="a-upload-progressing a-upload-file-list-item ready">
      {withThumbnail
        ? (
          <div className="a-upload-file-type-image">
            <img src={toImageDataUrl(file.image)} alt="attachment" />
          </div>
        )
        : <span className="a-upload-file-type-icon appkiticon icon-news-fill"/>
      }
      <span className="fileName">
        {file.name}
      </span>
      <AppkitIcon
        icon="circle-delete"
        size={16}
        onClick={removeHandler}
        className="appkiticon"
      />
    </div>
  );
};

SingleAttachment.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    url: PropTypes.string,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  withThumbnail: PropTypes.bool,
};

export default SingleAttachment;
